import { LayoutGrid } from "lucide-react";
import { AC } from "@/constants/testIds";
import {
  ACCESS_LEVELS,
  CHART_PARENT_TAB,
  accessLevelLabel,
  chartSubtabGroups,
  mainTabLevel,
} from "@/lib/maintabAccess";

export default function MainTabAccessMatrix({
  matrix,
  onChange,
  disabled,
  defaultMatrix,
  hasOverride,
  testId = AC.mainMatrix,
}) {
  const groups = chartSubtabGroups();
  return (
    <div className="ac-matrix-stack" data-testid={testId}>
      <section className="ac-matrix">
        <header className="ac-matrix-head ac-matrix-head--main">
          <LayoutGrid className="h-4 w-4" aria-hidden="true" />
          <h3>Main Tabs</h3>
        </header>
        <table className="ac-matrix-table">
          <thead>
            <tr>
              <th scope="col">Main Tab</th>
              {ACCESS_LEVELS.map((level) => (
                <th key={level.id} scope="col">
                  {level.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(matrix || []).map((tab) => {
              const selected = tab.accessLevel || "none";
              const orgDefault = defaultMatrix ? mainTabLevel(defaultMatrix, tab.id) : null;
              return (
                <tr key={tab.id} data-testid={`ac-maintab-row-${tab.id}`}>
                  <th scope="row">
                    <span>{tab.label}</span>
                    {orgDefault ? (
                      <span className="ac-tab-meta">
                        Organization/User Class: {accessLevelLabel(orgDefault)}
                        {hasOverride
                          ? ` · Individual Override: ${accessLevelLabel(selected)}`
                          : " · Individual Override: Organization default"}
                        {` · Effective: ${accessLevelLabel(selected)}`}
                      </span>
                    ) : null}
                  </th>
                  {ACCESS_LEVELS.map((level) => {
                    const inputId = `ac-maintab-${tab.id}-${level.id}`;
                    return (
                      <td key={level.id}>
                        <label className="ac-radio" htmlFor={inputId}>
                          <input
                            id={inputId}
                            type="radio"
                            name={`ac-maintab-${tab.id}`}
                            value={level.id}
                            checked={selected === level.id}
                            disabled={disabled}
                            data-testid={`ac-radio-maintab-${tab.id}-${level.id}`}
                            onChange={() => onChange(tab.id, level.id)}
                          />
                          <span className="sr-only">
                            {tab.label} {level.label}
                          </span>
                        </label>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>

      <section className="ac-hierarchy" data-testid={AC.hierarchy}>
        <h4>Patients chart subtabs</h4>
        <p>
          Chart subtabs are children of the <strong>Patients</strong> Main Tab. Effective
          subtab access cannot exceed the Patients permission.
        </p>
        {groups.map((area) => (
          <div key={area.id} className="ac-hierarchy-area">
            <strong>{area.label}</strong>
            <span>{area.subtabs.map((item) => item.label).join(", ")}</span>
          </div>
        ))}
        <p className="ac-hierarchy-note">
          Parent tab: {CHART_PARENT_TAB}. Example: Patients = Read and Notes = Write yields
          effective Notes = Read. Patients = No Access yields effective No Access for every
          chart subtab.
        </p>
      </section>
    </div>
  );
}
